import {connect} from 'react-redux';

import Base from './Base';

const Start = props => <Base {...props} id="start" />;

const mapStateToProps = ({animationStart: index}) => ({index});

export default connect(mapStateToProps)(Start);
